import type { IPushNotificationService } from "@saif-reporting/domain/interfaces/services/IPushNotificationService.js";
import type { ContainerType } from "~/container";
import type { IApi } from "~/interfaces/IApi";

export class PushNotificationService implements IPushNotificationService {
  private readonly api: IApi;
  constructor({ baseApi }: ContainerType) {
    this.api = baseApi;
  }

  async subscribe(sub: PushSubscription): Promise<void> {
    return await this.api.$fetch(`/push-notifications/subscribe`, { body: sub, method: "post" });
  }

  async unsubsribe(sub: PushSubscription): Promise<void> {
    return await this.api.$fetch(`/push-notifications/unsubscribe`, { body: sub, method: "post" });
  }
}
